import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { SubGroupQueries } from '@/services/groupsManagement/subGroups.queries';

export const useSubGroupDetail = (subGroupId: string) => {
  const { data, isLoading } = useQuery({
    ...SubGroupQueries.detail(subGroupId),

    enabled: !!subGroupId,
  });

  return { subGroupDetail: data?.data, isLoading };
};
